/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UnistackZoneListRsp } from '../models/unistack-zone-list-rsp';
import { UnistackZoneCreateRsp } from '../models/unistack-zone-create-rsp';
import { UnistackZoneCreateReq } from '../models/unistack-zone-create-req';
import { UnistackZoneLookupRsp } from '../models/unistack-zone-lookup-rsp';
import { UnistackZoneUpdateRsp } from '../models/unistack-zone-update-rsp';
import { UnistackZoneUpdateReq } from '../models/unistack-zone-update-req';
import { UnistackZoneDeleteRsp } from '../models/unistack-zone-delete-rsp';
@Injectable({
  providedIn: 'root',
})
class ZoneServiceService extends __BaseService {
  static readonly ZoneListPath = '/api/unistack/v0/zones';
  static readonly ZoneCreatePath = '/api/unistack/v0/zones';
  static readonly ZoneLookupPath = '/api/unistack/v0/zones/{uuid}';
  static readonly ZoneUpdatePath = '/api/unistack/v0/zones/{uuid}';
  static readonly ZoneDeletePath = '/api/unistack/v0/zones/{uuid}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `ZoneServiceService.ZoneListParams` containing the following parameters:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `filter`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  ZoneListResponse(params: ZoneServiceService.ZoneListParams): __Observable<__StrictHttpResponse<UnistackZoneListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    if (params.filter != null) __params = __params.set('filter', params.filter.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/zones`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackZoneListRsp>;
      })
    );
  }
  /**
   * @param params The `ZoneServiceService.ZoneListParams` containing the following parameters:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `filter`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  ZoneList(params: ZoneServiceService.ZoneListParams): __Observable<UnistackZoneListRsp> {
    return this.ZoneListResponse(params).pipe(
      __map(_r => _r.body as UnistackZoneListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  ZoneCreateResponse(body: UnistackZoneCreateReq): __Observable<__StrictHttpResponse<UnistackZoneCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/zones`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackZoneCreateRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  ZoneCreate(body: UnistackZoneCreateReq): __Observable<UnistackZoneCreateRsp> {
    return this.ZoneCreateResponse(body).pipe(
      __map(_r => _r.body as UnistackZoneCreateRsp)
    );
  }

  /**
   * @param params The `ZoneServiceService.ZoneLookupParams` containing the following parameters:
   *
   * - `uuid`: string uuid = 1 [(grpc.gateway.protoc_gen_swagger.options.openapiv2_field) = {required: ['uuid']}, (tagger.tags) = "mapstructure:\"id\""];
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  ZoneLookupResponse(params: ZoneServiceService.ZoneLookupParams): __Observable<__StrictHttpResponse<UnistackZoneLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/zones/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackZoneLookupRsp>;
      })
    );
  }
  /**
   * @param params The `ZoneServiceService.ZoneLookupParams` containing the following parameters:
   *
   * - `uuid`: string uuid = 1 [(grpc.gateway.protoc_gen_swagger.options.openapiv2_field) = {required: ['uuid']}, (tagger.tags) = "mapstructure:\"id\""];
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  ZoneLookup(params: ZoneServiceService.ZoneLookupParams): __Observable<UnistackZoneLookupRsp> {
    return this.ZoneLookupResponse(params).pipe(
      __map(_r => _r.body as UnistackZoneLookupRsp)
    );
  }

  /**
   * @param params The `ZoneServiceService.ZoneUpdateParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  ZoneUpdateResponse(params: ZoneServiceService.ZoneUpdateParams): __Observable<__StrictHttpResponse<UnistackZoneUpdateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/unistack/v0/zones/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackZoneUpdateRsp>;
      })
    );
  }
  /**
   * @param params The `ZoneServiceService.ZoneUpdateParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  ZoneUpdate(params: ZoneServiceService.ZoneUpdateParams): __Observable<UnistackZoneUpdateRsp> {
    return this.ZoneUpdateResponse(params).pipe(
      __map(_r => _r.body as UnistackZoneUpdateRsp)
    );
  }

  /**
   * @param uuid undefined
   * @return A successful response.
   */
  ZoneDeleteResponse(uuid: string): __Observable<__StrictHttpResponse<UnistackZoneDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/unistack/v0/zones/${uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackZoneDeleteRsp>;
      })
    );
  }
  /**
   * @param uuid undefined
   * @return A successful response.
   */
  ZoneDelete(uuid: string): __Observable<UnistackZoneDeleteRsp> {
    return this.ZoneDeleteResponse(uuid).pipe(
      __map(_r => _r.body as UnistackZoneDeleteRsp)
    );
  }
}

module ZoneServiceService {

  /**
   * Parameters for ZoneList
   */
  export interface ZoneListParams {
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
    filter?: string;
    fields?: Array<'field_all' | 'field_uuid' | 'field_id' | 'field_name' | 'field_desc' | 'field_status' | 'field_created_at' | 'field_updated_at' | 'field_deleted_at'>;
  }

  /**
   * Parameters for ZoneLookup
   */
  export interface ZoneLookupParams {

    /**
     * string uuid = 1 [(grpc.gateway.protoc_gen_swagger.options.openapiv2_field) = {required: ['uuid']}, (tagger.tags) = "mapstructure:\"id\""];
     */
    uuid: string;
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
    fields?: Array<'field_all' | 'field_uuid' | 'field_id' | 'field_name' | 'field_desc' | 'field_status' | 'field_created_at' | 'field_updated_at' | 'field_deleted_at'>;
  }

  /**
   * Parameters for ZoneUpdate
   */
  export interface ZoneUpdateParams {
    uuid: string;
    body: UnistackZoneUpdateReq;
  }
}

export { ZoneServiceService }
